// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .listing-field {
  display: inline;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;
}

:host ::ng-deep .listing-field:hover {
  background-color: #efefef;
}

:host ::ng-deep .listing-field:hover .listing-field-button {
  display: inline;
}

:host ::ng-deep .listing-field-button {
  display: none;
  margin: 0 2px;
  cursor: pointer;
}

:host ::ng-deep .listing-field-button:hover {
  transform: scale(1.2);
}

.fr-popup.fr-active {
  display: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
